import config from "../config";
import request, { requestOptions } from "../utils/request";
const baseUrl = `${config.API_ROOT}/app/api-keys`;

const Api = {
  async getKeys() {
    const options = await requestOptions("GET", {}, true);
    const url = `${baseUrl}/`;
    return request(url, options);
  },
  async createKey() {
    const options = await requestOptions("POST", {}, true);
    const url = `${baseUrl}/`;
    return request(url, options);
  },
  async updateKey(id) {
    const options = await requestOptions("POST", {}, true);
    const url = `${baseUrl}/${id}`;
    return request(url, options);
  },
  async refreshKey(id) {
    const options = await requestOptions("POST", {}, true);
    const url = `${baseUrl}/${id}/refresh`;
    return request(url, options);
  },
};

export default Api;
